import React from 'react';
import PropTypes from 'prop-types';
import ReactCountryFlag from 'react-country-flag';
import makeStyles from '@mui/styles/makeStyles';

import { generateKey } from 'shared/functions';

const useStyles = makeStyles(theme => ({
  flag: {
    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const FlagsList = ({ countryCodes, ...props }) => {
  const classes = useStyles();

  return (
    <div {...props}>
      {countryCodes.map((code, index) => (
        <ReactCountryFlag className={classes.flag} key={generateKey(index, code)} countryCode={code} svg />
      ))}
    </div>
  );
};

FlagsList.propTypes = {
  countryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FlagsList;
